<template>
    <div>
        <h3 class="card__heading service-options__card-heading">Additional Services</h3>
        <p class="card__text">
            At Stellantis &You UK, we have a range of fixed-priced repairs to maintain your vehicle to the highest standard possible. These are the recommended services you can add to your {{ vehicleDetails.make + " " + vehicleDetails.model }} to keep it safe, reliable and in pristine condition, so you can drive with full peace of mind.
        </p>
        <div v-for="(item, index) in additonalServices" :key="item.id" class="service-options__radio-section">
            <div class="service-options__radio-container">
                <label class="service-options__radio-container-label" :for="`additionalservice${item.id}`" >
                    <div class="service-options__radio-label">
                        <div class="service-options__label-left">
                            <span class="service-options__label-text">{{ item.display_name }}</span>
                        </div>
                        <div class="service-options__label-right">
                            <span v-if="item.description" class="service-options__label-info--desktop" @click.prevent.stop="openModal(item)">i</span>
                            <span class="service-options__price-with-switch" v-if="item.price > 0">
                                {{item.display_price }}
                            </span>
                            <span v-if="item.description" class="service-options__label-info--mobile" @click.prevent.stop="openModal(item)">i</span>
                            <label :for="`additionalservice${item.id}`" class="service-options__switch">
                                <input type="checkbox" :id="`additionalservice${item.id}`"
                                    :name="`additionalservice${item.id}`"
                                    class="service-options__switch-input"
                                    :true-value="item"
                                    :false-value="null"
                                    v-model="selectedOptions.additional_services[index]" />
                                <span class="service-options__slider"></span>
                                <span class="service-options__yes">Yes</span>
                                <span class="service-options__no">No</span>
                            </label>
                        </div>
                    </div>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    props: {
        additonalServices: {
            type: Array,
            required: true,
        },
        selectedOptions: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapState("OSB", [
            "nonFranchiseVehicle",
            "otherSelected",
            "pricingData",
            "selectedVehicle",
        ]),

        vehicleDetails() {
            if (this.otherSelected) {
                return this.nonFranchiseVehicle;
            }

            return this.selectedVehicle;
        },
    },
    methods: {
        openModal(service) {
            this.$emit('open-modal', service);
        },
    },
}
</script>